<template>
  <div class="forgot-success">
    <h1 class="form-title">{{ t('auth.forgot_success.title') }}</h1>
    
    <div class="message-container">
      <p class="message-text">{{ t('auth.forgot_success.text') }}</p>
      <p class="message-text highlight">{{ t('auth.forgot_success.deadline', { minutes: deadlineText }) }}</p>
      <p class="message-text">{{ t('auth.forgot_success.action_required') }}</p>
      
      <p class="spam-note">{{ t('auth.forgot_success.spam_note') }}</p>
    </div>

    <div class="form-actions">
      <router-link to="/login" class="btn-login">
        {{ t('auth.forgot_success.btn_login') }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { useLanguage } from '@/composables/useLanguage'

const { t, currentLanguage } = useLanguage()
const tokenExpirationMinutes = import.meta.env.VITE_PASSWORD_RESET_TOKEN_EXPIRATION_MINUTES || 60
const deadlineText = tokenExpirationMinutes + ' ' + (currentLanguage.value === 'it' ? 'minuti' : 'minutes')
</script>

<style scoped>
.forgot-success {
  position: relative;
  z-index: 10;
}

.form-title {
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #000000;
  margin-bottom: 24px;
  text-transform: uppercase;
}

.message-container {
  margin-bottom: 40px;
  text-align: center;
}

.message-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #666666;
  margin-bottom: 15px;
  line-height: 1.6;
}

.highlight {
  color: #000000;
  font-weight: 900;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.spam-note {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #999999;
  margin-top: 25px;
  font-style: normal;
  text-transform: none;
  letter-spacing: 0.3px;
  opacity: 0.8;
}

.form-actions {
  margin-top: 30px;
}

.btn-login {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 15px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  background: #000000;
  border: none;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
}

.btn-login:hover {
  background: var(--dark-teal);
  box-shadow: 0 8px 20px -6px rgba(0,140,149,0.5);
  color: #ffffff;
  transform: translateY(1px);
}

@media (max-width: 600px) {
  .form-title {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .message-text {
    font-size: 13px;
  }
}
</style>
